import {Avatar, Col, Skeleton} from 'antd'
import {FollowButton} from 'components/Feed/FollowButton'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useEffect, useState} from 'react'
import {ImLibrary} from 'react-icons/im'
import ServerContext from 'views/Server/ServerContext'
import {getLocationLines} from 'views/Shared'

const OrganizationMeta = () => {
  const t = useTranslate()

  const { isSm } = useContext(LayoutContext)

  const { item = {} } = useContext(ServerContext)

  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(!_.has(item, 'description'))
  }, [item.description])

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false)
    }, 500)
      return () => clearTimeout(timer);
  }, [])

  if (_.isEmpty(item)) {
    return null
  }

  return (
    <Col className="space-y-3 p-col-0">
      {item.avatar ? (
        <Avatar
          shape="square"
          src={item.avatar}
          className="border mb-5 content-center rounded-lg"
          size={150}
        />
      ) : isSm ? (
        <span />
      ) : (
        <div
          className="background-200 flex justify-center items-center rounded-lg"
          style={{ width: '8rem', height: '8rem' }}>
          <ImLibrary
            size={80}
            className="text-color-500"
          />
        </div>
      )}

      <p className="font-bold text-2xl text-primary">{item.title}</p>
      {isLoading ? (
        <Skeleton active={isLoading} />
      ) : (
        <p className="font-light">{item.description}</p>
      )}
      <ItemInfo
        label={t('address')}
        value={getLocationLines(item)}
      />
      <ItemInfo
        label={t('email')}
        value={_.get(item, 'contacts.0.email')}
      />
      <ItemInfo
        label={t('phone')}
        value={_.get(item, 'contacts.0.phone')}
      />

      <div className="my-6 text-right">
        <FollowButton
          size="medium"
          item={item}
        />
      </div>
    </Col>
  )
}

const ItemInfo = ({ label, value }) =>
  _.isEmpty(value) ? null : (
    <div className="flex flex-col">
      <p className="text-xs font-light text-color-400 mb-2">{label}</p>
      <p className="text-sm font-bold pl-3">{value}</p>
    </div>
  )

export default OrganizationMeta
